// extracted by mini-css-extract-plugin
export default {"newSiteBtn":"sites-page_newSiteBtn__JowTV"};